'use strict';

const jQuery = require('jquery');

const ContentManager = require('./../component/ContentManager');
const Mediator = require('./../../../core/mediator');
const Container = require('./../../../core/container');

let currentBurgerStatus;
let currentButtonStatus;

const addButton = function(content) {
    if (content.type !== 'Basic/Menu') {
        return;
    }

    let $menuElt = jQuery('<li class="menu-add-parameter"><a href="#"><i class="icon icon-setting"></i></a></li>');
    let $btn = $menuElt.find('a');
    let $target = content.$.find('li:eq(0)');

    $btn.on('click', function(e) {
        e.preventDefault();

        Mediator.publish('content:plugin:parameter', content);
    });

    if ($target.length === 0) {
        $target = content.$.find('ul').length ? content.$.find('ul') : content.$;
        $target.append($menuElt);
    } else {
        $menuElt.insertBefore($target);
    }
};

module.exports.apply = addButton;

module.exports.init = function() {
    jQuery('[data-bb-identifier^="Basic/Menu"]').each(function() {
        if (Container.get('isAllowedTo')('GLOBAL_CONTENT_FEATURE')) {
            addButton(ContentManager.getContentByNode(jQuery(this)));
        }
    });
};

module.exports.destroy = function() {
    jQuery('.menu-add-parameter').remove();
};

module.exports.afterParametersShown = (object) => {
    let content = object.content;

    if (content.type === 'Basic/Menu') {
        currentBurgerStatus = content.data.parameters.burger.value;
        currentButtonStatus = content.data.parameters.button_hide_on_mobile.value;
    }
};

module.exports.afterSubmitParameters = (content) => {
    if (content.type === 'Basic/Menu') {
        if (currentBurgerStatus !== content.getParameter('burger').value || currentButtonStatus !== content.getParameter('button_hide_on_mobile').value) {
            window.location.reload();
        }
    }
};
